var canvas, canvas2, text, newText, zoom, cWidth = 2000, cHeight = 2000,
    halfWidth = cWidth / 2, halfHeight = cHeight / 2,
    obj, array = [], get_data, sizeCrop,
    scale_factor, newheight, leftOb, imageUrl,
    placeholderimg1, placeholderimg2, placeholderimg3,
    placeholderimg4, placeholderimg5, placeholderimg6,
    placeholderimg7, placeholderimg8, placeholderimg9,
    placeholderimg10, placeholderimg11, placeholderimg12,
    img, leftMarker, rightMarker, vLine;

var loader = jQuery('#customLoader'),
    cropper = "", canvas, boxWidth, boxLeft, boxTop,
    croppedSize, orientations, aspectRatio, reCroper,
    c1img1;

var outLine,sizeBmW = 715, sizeBmH = 450,
    sizeB1W = 287, sizeB1H = 322,
    sizeB2W = 326, sizeB2H = 275;

imageUrl = document.getElementById('imageContainer').getAttribute('data-image-url');



let digitImg = document.querySelector("#clock_digits");
let clockDigitImage = new fabric.Image(digitImg, {
  left: 465,   
  top: 470,
  scaleX: 1.05,
  scaleY: 1.05,
  selectable: false
});

let needlesImg = document.querySelector("#clock_needles");
let clockNeedlesImage = new fabric.Image(needlesImg, {
  left: 0,   
  top: 0,
  scaleX: 1.95,
  scaleY: 1.95,
  selectable: false
});

window['canvas2'] = new fabric.Canvas('canvas2', {
  width: cWidth,
  height: cHeight
});

window['canvas2'].add(clockDigitImage);
window['canvas2'].add(clockNeedlesImage);
clockNeedlesImage.bringToFront();
addModify(window['canvas2']);



function applyGoldStroke(rect) {
  rect.set({
    strokeUniform: true,
    objectCaching: false
  });

  rect.set('stroke', new fabric.Gradient({
    type: 'linear',
    gradientUnits: 'pixels',
    coords: {
      x1: 0,
      y1: 0,
      x2: rect.width,
      y2: rect.height
    },
    colorStops: [
      { offset: 0.0, color: '#f8f1b0' },
      { offset: 0.4, color: '#f3dc8a' },
      { offset: 0.7, color: '#efc46a' },
      { offset: 1.0, color: '#e3a24d' }
    ]
  }));
}



window['placeholderimg1'] = new fabric.Rect({
  left: 1341,
  top: 363,
  width: sizeB2W,
  height: sizeB2H,
  fill: 'rgba(0,0,0,0.1)',
  strokeWidth: 9
});
applyGoldStroke(window['placeholderimg1']);

window['placeholderimg2'] = new fabric.Rect({
  left: 1617,
  top: 663,
  width: sizeB2W,
  height: sizeB2H,
  fill: 'rgba(0,0,0,0.1)',
  strokeWidth: 9
});
applyGoldStroke(window['placeholderimg2']);

window['placeholderimg3'] = new fabric.Rect({
  left: 1735,
  top: 990,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
  strokeWidth: 9
});
applyGoldStroke(window['placeholderimg3']);

window['placeholderimg4'] = new fabric.Rect({
  left: 1617,
  top: 1325,
  width: sizeB2W,
  height: sizeB2H,
  fill: 'rgba(0,0,0,0.1)',
  strokeWidth: 9
});
applyGoldStroke(window['placeholderimg4']);

window['placeholderimg5'] = new fabric.Rect({
  left: 1341,
  top: 1631,
  width: sizeB2W,
  height: sizeB2H,
  fill: 'rgba(0,0,0,0.1)',
  strokeWidth: 9
});
applyGoldStroke(window['placeholderimg5']);

window['placeholderimg6'] = new fabric.Rect({
  left: 1001,
  top: 1732,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
  strokeWidth: 9
});
applyGoldStroke(window['placeholderimg6']);

window['placeholderimg7'] = new fabric.Rect({
  left: 661,
  top: 1631,
  width: sizeB2W,
  height: sizeB2H,
  fill: 'rgba(0,0,0,0.1)',
  strokeWidth: 9
});
applyGoldStroke(window['placeholderimg7']);

window['placeholderimg8'] = new fabric.Rect({
  left: 390,
  top: 1325,
  width: sizeB2W,
  height: sizeB2H,
  fill: 'rgba(0,0,0,0.1)',
  strokeWidth: 9
});
applyGoldStroke(window['placeholderimg8']);

window['placeholderimg9'] = new fabric.Rect({
  left: 257,
  top: 990,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
  strokeWidth: 9
});
applyGoldStroke(window['placeholderimg9']);

window['placeholderimg10'] = new fabric.Rect({
  left: 390,
  top: 663,
  width: sizeB2W,
  height: sizeB2H,
  fill: 'rgba(0,0,0,0.1)',
  strokeWidth: 9
});
applyGoldStroke(window['placeholderimg10']);

window['placeholderimg11'] = new fabric.Rect({
  left: 662,
  top: 363,
  width: sizeB2W,
  height: sizeB2H,
  fill: 'rgba(0,0,0,0.1)',
  strokeWidth: 9
});
applyGoldStroke(window['placeholderimg11']);

window['placeholderimg12'] = new fabric.Rect({
  left: 1001,
  top: 286,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
  strokeWidth: 9
});
applyGoldStroke(window['placeholderimg12']);

window['canvas2'].add(window['placeholderimg1'], window['placeholderimg2'], window['placeholderimg3'], window['placeholderimg4'], window['placeholderimg5'], window['placeholderimg6'],
                      window['placeholderimg7'], window['placeholderimg8'], window['placeholderimg9'], window['placeholderimg10'],
                      window['placeholderimg11'], window['placeholderimg12']);



window['border1'] = new fabric.Rect({
  left: 1341,
  top: 363,
  width: sizeB2W,
  height: sizeB2H,
  fill: 'transparent',
  strokeWidth: 9
});
applyGoldStroke(window['border1']);

window['border2'] = new fabric.Rect({
  left: 1617,
  top: 663,
  width: sizeB2W,
  height: sizeB2H,
  fill: 'rgba(0,0,0,0.1)',
  strokeWidth: 9
});
applyGoldStroke(window['border2']);

window['border3'] = new fabric.Rect({
  left: 1735,
  top: 990,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'transparent',
  strokeWidth: 9
});
applyGoldStroke(window['border3']);

window['border4'] = new fabric.Rect({
  left: 1617,
  top: 1325,
  width: sizeB2W,
  height: sizeB2H,
  fill: 'transparent',
  strokeWidth: 9
});
applyGoldStroke(window['border4']);

window['border5'] = new fabric.Rect({
  left: 1341,
  top: 1631,
  width: sizeB2W,
  height: sizeB2H,
  fill: 'transparent',
  strokeWidth: 9
});
applyGoldStroke(window['border5']);

window['border6'] = new fabric.Rect({
  left: 1001,
  top: 1732,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'transparent',
  strokeWidth: 9
});
applyGoldStroke(window['border6']);

window['border7'] = new fabric.Rect({
  left: 661,
  top: 1631,
  width: sizeB2W,
  height: sizeB2H,
  fill: 'transparent',
  strokeWidth: 9
});
applyGoldStroke(window['border7']);

window['border8'] = new fabric.Rect({
  left: 390,
  top: 1325,
  width: sizeB2W,
  height: sizeB2H,
  fill: 'transparent',
  strokeWidth: 9
});
applyGoldStroke(window['border8']);

window['border9'] = new fabric.Rect({
  left: 257,
  top: 990,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'transparent',
  strokeWidth: 9
});
applyGoldStroke(window['border9']);

window['border10'] = new fabric.Rect({
  left: 390,
  top: 663,
  width: sizeB2W,
  height: sizeB2H,
  fill: 'transparent',
  strokeWidth: 9
});
applyGoldStroke(window['border10']);

window['border11'] = new fabric.Rect({
  left: 662,
  top: 363,
  width: sizeB2W,
  height: sizeB2H,
  fill: 'transparent',
  strokeWidth: 9
});
applyGoldStroke(window['border11']);

window['border12'] = new fabric.Rect({
  left: 1001,
  top: 286,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'transparent',
  strokeWidth: 9
});
applyGoldStroke(window['border12']);

window['canvas2'].add(window['border1'], window['border2'], window['border3'], window['border4'], window['border5'], window['border6'],
                      window['border7'], window['border8'], window['border9'], window['border10'],
                      window['border11'], window['border12']);


document.getElementById('image_upload_topleft').addEventListener('change',function(e){
   canvas = window['canvas2'];
   img = window['placeholderimg1'];
   outline = window['border1'];
   available_height = img.height;
   sizeCrop = '1.19';
   reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
   readURL2(e.target);
 });

document.getElementById('image_upload_topmiddle').addEventListener('change',function(e){
  canvas = window['canvas2'];
  img = window['placeholderimg2'];
  outline = window['border2'];
  available_height = img.height;
  sizeCrop = '1.19';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  readURL2(e.target);
});

document.getElementById('image_upload_topright').addEventListener('change',function(e){
  canvas = window['canvas2'];
  img = window['placeholderimg3'];
  outline = window['border3'];
  available_height = img.height;
  sizeCrop = '0.89';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  readURL2(e.target);
});

document.getElementById('image_upload_middleleft').addEventListener('change',function(e){
  canvas = window['canvas2'];
  img = window['placeholderimg4'];
  outline = window['border4'];
  available_height = img.height;
  sizeCrop = '1.19';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  readURL2(e.target);
});

document.getElementById('image_upload_middlecenter').addEventListener('change', function(e){
  canvas = window['canvas2'];
  img = window['placeholderimg5'];
  outline = window['border5'];
  available_height = img.height;
  sizeCrop = '1.19';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  readURL2(e.target);
});

document.getElementById('image_upload_bottomleft').addEventListener('change', function(e){
  canvas = window['canvas2'];
  img = window['placeholderimg6'];
  outline = window['border6'];
  available_height = img.height;
  sizeCrop = '0.89';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  readURL2(e.target);
});

document.getElementById('image_upload_bottommiddle').addEventListener('change', function(e){
  canvas = window['canvas2'];
  img = window['placeholderimg7'];
  outline = window['border7'];
  available_height = img.height;
  sizeCrop = '1.19';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  readURL2(e.target);
});

document.getElementById('image_upload_bottomright').addEventListener('change', function(e){
  canvas = window['canvas2'];
  img = window['placeholderimg8'];
  outline = window['border8'];
  available_height = img.height;
  sizeCrop = '1.19';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  readURL2(e.target);
});

document.getElementById('image_upload_nine').addEventListener('change', function(e){
  canvas = window['canvas2'];
  img = window['placeholderimg9'];
  outline = window['border9'];
  available_height = img.height;
  sizeCrop = '0.89';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  readURL2(e.target);
});

document.getElementById('image_upload_ten').addEventListener('change', function(e){
  canvas = window['canvas2'];
  img = window['placeholderimg10'];
  outline = window['border10'];
  available_height = img.height;
  sizeCrop = '1.19';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  readURL2(e.target);
});

document.getElementById('image_upload_eleven').addEventListener('change', function(e){
  canvas = window['canvas2'];
  img = window['placeholderimg11'];
  outline = window['border11'];
  available_height = img.height;
  sizeCrop = '1.19';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  readURL2(e.target);
});

document.getElementById('image_upload_twelve').addEventListener('change', function(e){
  canvas = window['canvas2'];
  img = window['placeholderimg12'];
  outline = window['border12'];
  available_height = img.height;
  sizeCrop = '0.89';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  readURL2(e.target);
});

clockNeedlesImage.bringToFront();



function createGoldTextGradient(textObj) {
  return new fabric.Gradient({
    type: 'linear',
    gradientUnits: 'pixels',
    coords: {
      x1: 0,
      y1: 0,
      x2: 0,
      y2: textObj.fontSize
    },
    colorStops: [
      { offset: 0.0, color: '#fff4b0' },
      { offset: 0.4, color: '#f5d77a' },
      { offset: 0.7, color: '#d4a64a' },
      { offset: 1.0, color: '#9c6a1b' }
    ]
  });
}




window['text1Page'] = new fabric.Text('check', {
  left: 1015,
  top: 1175,
  fontSize: 125,
  fontFamily: 'Caveat',
  fontWeight: 'bolder',

  // 🔥 CRITICAL FIXES
  fill: '#000',
  objectCaching: false,
  padding: 15,
  paintFirst: 'fill',

  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});

// Apply gradient AFTER object exists
window['text1Page'].set({
  fill: createGoldTextGradient(window['text1Page'])
});
window['text1Page'].initDimensions();


var fontName = window['text1Page'].fontFamily;
jQuery('.choose_font').val("'" + fontName + "'").trigger('change');

// Add to canvas
window['canvas2'].add(window['text1Page']);

// Clear text on input focus if default
document.getElementById('text_1').addEventListener('focus', function () {
  if (window['text1Page'].text === 'Haniya Khan') {
    window['text1Page'].set('text', '');
    window['text1Page'].set('fill', createGoldTextGradient(window['text1Page']));
    window['canvas2'].renderAll();
  }
});


function fitTextToWidth(textObj, maxWidth) {
  let fontSize = 125;
  textObj.set({ fontSize });

  while (textObj.getScaledWidth() > maxWidth && fontSize > 5) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  // 🔥 force recalculation (fixes cut)
  textObj.setCoords();
  window['canvas2'].requestRenderAll();
}


document.getElementById('text_1').addEventListener('input', function (e) {
  window['text1Page'].set('text', e.target.value || ' ');
  window['text1Page'].set({
    fill: createGoldTextGradient(window['text1Page'])
  });

  fitTextToWidth(window['text1Page'], 650);
  window['text1Page'].initDimensions();
  window['canvas2'].renderAll();
});




var maxWidth2 = 600;
var maxHeight2 = 120;

window['text2Page'] = new fabric.Text('Check', {
  left: 1015,
  top: 1300,
  fontSize: 80,
  fontWeight: 'bolder',
  fontFamily: 'Caveat',
  textAlign: 'center',

  // 🔥 CRITICAL FIXES
  fill: '#000',
  objectCaching: false,
  padding: 12,
  paintFirst: 'fill',

  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});

window['text2Page'].set({
  fill: createGoldTextGradient(window['text2Page'])
});
window['text2Page'].initDimensions();

var fontName2 = window['text2Page'].fontFamily;
jQuery('.choose_font2').val("'" + fontName2 + "'").trigger('change');

window['canvas2'].add(window['text2Page']);


var minFontSize2 = 15;
var maxFontSize2 = 80;

// Clear text on input focus if default
document.getElementById('text_2').addEventListener('focus', function () {
  if (window['text2Page'].text === '23 July 2002') {
    window['text2Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});


// Helper: Adjust font size to fit both width and height
function autoFitText2(textbox, maxW, maxH) {
  let fontSize = maxFontSize2;

  textbox.set({ fontSize });

  while (
    (textbox.width > maxW || textbox.calcTextHeight() > maxH) &&
    fontSize > minFontSize2
  ) {
    fontSize -= 1;
    textbox.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

// On input update
document.getElementById('text_2').addEventListener('input', function (e) {
  window['text2Page'].set('text', e.target.value || ' ');
  window['text2Page'].set({
    fill: createGoldTextGradient(window['text2Page'])
  });

  fitTextToBox2(window['text2Page'], maxWidth2, maxHeight2);
  window['text2Page'].initDimensions();
  window['canvas2'].renderAll();
});


function fitTextToBox2(textObj, maxWidth2, maxHeight2) {
  let fontSize = maxFontSize2;

  textObj.set({ fontSize });

  // Helper function to get height (fabric.Text uses height property)
  function isTooBig() {
    return textObj.width > maxWidth2 || textObj.height > maxHeight2;
  }

  // Reduce font size until both width and height fit within limits
  while (isTooBig() && fontSize > minFontSize2) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}




function canvasMakeImg(canvas,zoom){
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function canvasBlock(canvas){
  zoom = jQuery('.product__media-outer').width();
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function setZoomMask(canvas,newZoomLevel){
  canvas.setZoom(newZoomLevel);
  canvas.setDimensions({
    width:  cWidth * newZoomLevel,
    height:  cHeight * newZoomLevel
  });
  canvas.renderAll();
}

function addModify(canvas){
  fabric.Object.prototype.transparentCorners = false;
  fabric.textureSize = 75497472;

  canvas.renderOnAddRemove = false;
  canvas.on('selection:cleared', function(e){
    object = e.target;
  });

  canvas.on('object:removed',function(e){
    object = e.target;
  });

  canvas.on('object:added', function(e){
    object = e.target;
    addControls(object);
    canvas.renderAll();
  });
  
  canvas.on('object:modified', function(e){
    object = e.target;
    canvas.renderAll();
  });
  
  canvas.on('selection:created', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('selection:updated', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('object:scaling', function(e){
    canvas.renderAll();
  });

  jQuery(window).on('load',function(){
    canvasBlock(canvas);
  });

  jQuery(window).on('resize',function(){
    canvasBlock(canvas);
  });
}

function addControls(object){
  var iconTL = document.createElement("img"),
      iconBR = document.createElement("img");
  
  iconTL.src = trashIcon;
  iconBR.src = resizeIcon;
  
  object.set({
    selectable:false,
    originX:"center",
    originY:"center",
    transparentCorners: false,
    borderColor: '#ddd',
    borderDashArray: [6,2],
    cornerStyle: 'circle',
    cornerColor: '#000',
    objectCaching: false,
    _controlsVisibility: {
      tr: false,
      tl: true,
      bl: false,
      br: true,
      mb: false,
      ml: false,
      mr: false,
      mt: false,
      mtr: false
    }
  });
  
  iconTL.onload = function() {
    fabric.Object.prototype.controls.tl = new fabric.Control({
      x: -0.5,
      y: -0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "pointer",
      mouseUpHandler: deleteHandler,
      render: renderIcon(iconTL),
      withConnection: true,
      cornerSize: 18,
    });
  };
  iconBR.onload = function() {
    fabric.Object.prototype.controls.br = new fabric.Control({
      x: 0.5,
      y: 0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "se-resize",
      mouseUpHandler:fabric.controlsUtils.scalingEqually,
      render: renderIcon(iconBR),
      withConnection: true,
      cornerSize: 18,
    });
  }
}

function renderIcon(icon) {
  return function (ctx, left, top, styleOverride, fabricObject) {
    const size = this.cornerSize;
    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
    ctx.drawImage(icon, -size / 2, -size / 2, size, size);
    ctx.restore();
  };
}

function deleteHandler(eventData,transform){
  var target = transform.target;
  activeOb = canvas.getActiveObject();
  canvas.remove(activeOb);
  canvas.renderAll();
}

initCropper();

function readURL2(input){
  loader.removeClass('hidden');
  jQuery('#tadaWidget').addClass('hidden');
  if(cropper == ""){
  }else {
    cropper.destroy();
  }
  if (input.files && input.files[0]) {
    var reader = new FileReader();
    reader.onload = function (e) {
      jQuery('#blah').attr('src', e.target.result);
      reCroper.attr('data-img',e.target.result);
    };
    reader.readAsDataURL(input.files[0]);
    setTimeout(initCropper, 2500);
  }
  clockNeedlesImage.bringToFront();
}

function addImage(e,placeholderimg,canvas){
  var file = e.target.files[0];
  var reader = new FileReader();
  reader.onload = function(event){
    var imgObj = new Image();
    imgObj.src = event.target.result;
    imgObj.onload = function(){
      var img = new fabric.Image(imgObj);
      img.set({
        left: placeholderimg.left,
        top: placeholderimg.top,
        selectable:true,
        scaleX: placeholderimg.width / img.width,
        scaleY: placeholderimg.height / img.height,
        clipPath: new fabric.Rect({
          width: img.width,
          height: img.height,
          rx: 20, // Apply border radius from placeholder
          ry: 20
        })
      });
    };
  };
  clockNeedlesImage.bringToFront();
  reader.readAsDataURL(file);
}

function addCroppedImg(imgurl){
  canvas.remove(img).renderAll();
  fabric.Image.fromURL(imgurl, function(newImg){
    const scale = newImg.width / img.width;
    newImg.set({
      left: img.left,
      top: img.top,
      originX: 'center',
      originY: 'center'
    });
    newImg.scaleToHeight(available_height);
    
    const clipPath = new fabric.Rect({
      width: newImg.width,
      height: newImg.height,
      rx: img.rx * scale,
      ry: img.ry * scale,
      left: 0,
      top: 0,
      originX: 'center',
      originY: 'center',
      fill: 'transparent'
    });
    
    newImg.clipPath = clipPath;


    canvas.add(newImg);
    canvas.bringToFront(outline);
    img = newImg;
    clockNeedlesImage.bringToFront();
    canvas.renderAll();
    
    /*const border = new fabric.Rect({
      width: img.width,
      height: img.height,
      rx: img.rx,
      ry: img.ry,
      left: img.left,
      top: img.top,
      originX: 'center',
      originY: 'center',
      fill: 'transparent',
      stroke: img.stroke,
      strokeWidth: img.strokeWidth,
      selectable: false
    });
    
    const group = new fabric.Group([newImg, border], {
      left: img.left,
      top: img.top,
      originX: 'center',
      originY: 'center',
      selectable: true
    });
    canvas.add(group).renderAll();*/
  });
}

function initCropper(){
  var image = document.getElementById('blah');
  cropper = new Cropper(image, {
    viewMode: 1,
    dragMode: 'move',
    aspectRatio: sizeCrop,
    restore: false,
    guides: false,
    center: true,
    highlight: true,
    cropBoxMovable: true,
    cropBoxResizable: true,
    toggleDragModeOnDblclick: false,
    data:{}
  });
  jQuery('.popupImg').show();
  jQuery('#tadaWidget').addClass('hidden');
  loader.addClass('hidden');
}

document.getElementById('crop_button').addEventListener('click', function(){
  loader.removeClass('hidden');
  jQuery('#tadaWidget').addClass('hidden');
  var imgurl =  cropper.getCroppedCanvas().toDataURL();
  addCroppedImg(imgurl);
  setTimeout(function(){
    reCroper.parent().removeClass('hidden');
    jQuery('.popupImg').hide();
    loader.addClass('hidden');
    jQuery('#tadaWidget').removeClass('hidden');
  },500);
});

document.getElementById('zoom_out').addEventListener('click', function(){
  cropper.zoom(-0.1);
});

document.getElementById('zoom_in').addEventListener('click', function(){
  cropper.zoom(0.1);
});

document.getElementById('reset_button').addEventListener('click', function(){
  cropper.reset();
});

document.getElementById('cancelCropper').addEventListener('click', function(){
  jQuery('.popupImg').hide();
  jQuery('#tadaWidget').removeClass('hidden');
});

jQuery(document).on('click','.btnReCrop', function(){
  loader.removeClass('hidden');
  imgurl = jQuery(this).attr('data-img');
  sizeCrop = jQuery(this).attr('data-ratio');
  img = window[jQuery(this).attr('data-obj')];
  canvas = window[jQuery(this).attr('data-canvas')];
  available_height = jQuery(this).attr('data-height');
  console.log(canvas);
  jQuery('#tadaWidget').addClass('hidden');
  setTimeout(function(){
    cropper.destroy();
    jQuery('#blah').attr('src',imgurl);
    initCropper();
    jQuery('.popupImg').show();
    loader.addClass('hidden');
  },150);
});

jQuery('.customColors').each(function(){
  colorBox = jQuery(this).attr('id');
  loadColorPicker(colorBox);
});

jQuery(document).on('change','.fontFamily',function(){
  var fontID = jQuery(this).attr('data-canvas'),
      textOb = jQuery(this).attr('data-obj');
  canvas = window[fontID];
  activeOb = window[textOb];
  activeOb.set({ fontFamily: this.value });
  canvas.renderAll();
  fitTextToWidth(window['text1Page'], 650);
  fitTextToBox2(window['text2Page'], maxWidth2, maxHeight2);
});

function loadColorPicker(colorBox){
  jQuery('#'+colorBox).colorpicker({
    inline: true,
    container: true,
    extensions:[{
      name: 'swatches',
      options:{
        colors:{
          'tetrad1': 'transparent',
          'tetrad2': '#e30405',
          'tetrad3': '#197b30',
          'tetrad4': '#0054a5',
          'tetrad5': '#ffcc00',
          'tetrad6': '#f6ebbe',
          'tetrad7': '#ffea00',
          'tetrad8': '#f8931d',
          'tetrad9': '#f499c2',
          'tetrad10': '#959595',
          'tetrad11': '#fef335',
          'tetrad12': '#a0400d',
          'tetrad13': '#000000',
          'tetrad14': '#604973',
          'tetrad15': '#afe8fc',
          'tetrad16': '#fffafa',
          'tetrad17': '#bc8cbe',
          'tetrad18': '#ff69b4',
          'tetrad19': '#93278f',
          'tetrad20': '#009987',
          'tetrad21': '#0af447',
          'tetrad22': '#00008b',
          'tetrad23': '#006400'
        },
        namesAsValues: false
      }
    }],
    template: '<div class="colorpicker">' +
      '<div class="colorpicker-saturation"><i class="colorpicker-guide"></i></div>' +
      '<div class="colorpicker-hue"><i class="colorpicker-guide"></i></div>' +
      '<div class="colorpicker-alpha">' +
      '   <div class="colorpicker-alpha-color"></div>' +
      '   <i class="colorpicker-guide"></i>' +
      '</div>' +
      '<div class="colorpicker-bar">' +
      '   <a href="javascript:void(0);" class="button btn-block colorOFF">Ok</a>'+
      '   <div class="ctn-icon-eyedropper dropper-eyedrop"><svg class="icon icon-eyedropper" viewBox="0 0 16 16">'+
      '   <path d="M13.354.646a1.207 1.207 0 0 0-1.708 0L8.5 3.793l-.646-.647a.5.5 0 1 0-.708.708L8.293 5l-7.147 7.146A.5.5 0 0 0 1 12.5v1.793l-.854.853a.5.5'+
      '   0 1 0 .708.707L1.707 15H3.5a.5.5 0 0 0 .354-.146L11 7.707l1.146 1.147a.5.5 0 0 0 .708-.708l-.647-.646 3.147-3.146a1.207'+
      '   1.207 0 0 0 0-1.708zM2 12.707l7-7L10.293 7l-7 7H2z"/></svg></div>'+
      '</div>' +
      '</div>'
  }).on('colorpickerCreate', function(){
    var colorBox = jQuery(this);
    setTimeout(function(){
      var colorID = colorBox.attr('id'),
        active = colorBox.find('.currentColor'),
        activeCOLOR = active.attr('value');
      colorBox.find('.colorBox').attr('style','background:'+activeCOLOR+';');
    },200);
  }).on('colorpickerChange', function(){
    var colorBox = jQuery(this);
    setTimeout(function(){
      var colorID = colorBox.attr('data-canvas'),
          textOb = colorBox.attr('data-obj'),
          active = colorBox.find('.currentColor'),
          activeCOLOR = active.attr('value');
      colorBox.find('.colorBox').attr('style','background:'+activeCOLOR+';');
      colorBox.attr('data-color',activeCOLOR);
      canvas = window[colorID];
      activeOb = window[textOb];
      sCAle = activeOb.scaleX;
      activeOb.set('fill',activeCOLOR);
      activeOb.scaleX = .5;
      activeOb.setCoords();
      canvas.renderAll();
      activeOb.scaleX = sCAle;
      activeOb.setCoords();
      canvas.renderAll();
    },200);
  });
  jQuery(document).on('click','.colorBox',function(){
    jQuery('.colorBox').each(function(){
      jQuery(this).next().hide();
    });
    jQuery(this).next().show();
  });
  jQuery(document).on('click','.colorOFF',function(){
    var parENt = jQuery(this).parent().parent(),
        toolBarBox = parENt.parent().parent().parent().attr('id');
    if(toolBarBox === 'labelBase'){
      parENt.parent().parent().parent().parent().removeClass('active');
    }else{
      parENt.hide();
    }
  });
}

jQuery(document).on('click','.dropper-eyedrop',function(){
  const eyeDropper = new EyeDropper();
  eyeDropper.open().then(result => {
    jQuery(this).parent().parent().parent().colorpicker('setValue', result.sRGBHex);
  }).catch(e => {
    console.error(e);
  });
});


jQuery(window).on('load',function(){
  canvasBlock(canvas2);
  window['text1Page'].set('text','Haniya Khan');
  window['text2Page'].set('text','23 July 2002');
  window['canvas2'].renderAll();
  // loadFirstImg();
});


function getCookie(name){
  let nameEQ = name + "=";
  let cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++){
    let cookie = cookies[i].trim();
    if(cookie.indexOf(nameEQ) === 0){
      return cookie.substring(nameEQ.length, cookie.length);
    }
  }
  return null;
}

window.addEventListener("load", function(){
  if(getCookie("firstVisit")){
    console.log("✅ Cookie exists:", getCookie("firstVisit"));
  } else{
    console.log("❌ Cookie does not exist!");
    document.cookie = "firstVisit=lamaPao; expires=" + new Date(Date.now() + 24 * 60 * 60 * 1000).toUTCString() + "; path=/;";
    location.reload();
  }
});


async function handleUpload(fileInputs,timeID){
  const temp_images = [];
  
  for (let input of fileInputs){
    const file = input.files[0]; // Only first file per input
    const croppedURL = jQuery(input).attr('data-cropped');
    if(croppedURL != ''){
      temp_images.push(croppedURL);
    }
    if(file){
      const base64 = await toBase64(file); // ✅ now safely inside async
      temp_images.push(base64);
    }
  }
  if(temp_images.length === 0){
    alert("Please select at least one image.");
    return;
  }
  const payload = {
    timeId: timeID,
    temp_images: temp_images
  };
  console.log(payload);
  try {
    const response = await fetch('//technology-architects.com/tasweer-modules/upload_client_img.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });
    
    const result = await response.json();
    console.log("Upload result:", result);
    var int = 1, wall = 1, upCrop;
    result.uploaded_images.forEach(img => {
      if(jQuery('#image'+int).length < 1){
        if (int % 2 === 0) {
          upCrop = 'User Uploaded ';
        }else{
          upCrop = 'Cropped ';
        }
        jQuery('#preview').append('<input type="hidden" id="image'+int+'" name="properties['+ upCrop + wall+']">');
        if(upCrop == 'User Uploaded '){
          wall += 1;
        }
      }
      if (img.status === "success") {
        jQuery('#image'+int).val(img.image_url);
        int += 1;
      } else {
        console.warn("Upload failed:", img.error);
      }
    });
    jQuery('.product-form__buttons .product-form__submit').trigger('click');
    loader.addClass('hidden');
  } catch (error) {
    console.error("Upload error:", error);
    alert("Upload failed.");
  }
}

// ✅ Convert a file to base64 string
function toBase64(file){
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

/* fetch Call */
var size,thumbnail;
var loadedObject,enterText,Font1,enterEvent,Font2,additionalInfo,wMark,svgMrk;
let pdfData = {};
jQuery(document).on('click','#download',function(){
  loader.removeClass('hidden');
  setTimeout(function(){
    const id = ['canvas2'];
    const canvas = window['canvas2'];
    size = 350;
    loadMark(id,canvas,size);
    size = 4000;
    removeMark(canvas,size);
    // hideExtras(canvas);
    canvas.remove(clockNeedlesImage);
    window['canvas2'] = canvas.toDataURL('image/png');
    enterText = jQuery('.enter_text input').val();
    Font1 = jQuery('.Font1 option:selected').val();
    enterEvent = jQuery('.enter_event textarea').val();
    Font2 = jQuery('.Font2 option:selected').val();
    additionalInfo = jQuery('.tShirtImg textarea').val();
    // showExtras(canvas);
    canvasBlock(canvas);
    fetch('//technology-architects.com/tasweer-modules/save_order.php',{
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body:  JSON.stringify({
        temp_image: window['canvas2t'],
        original_image: window['canvas2']
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log(data);
      var previewId = data[0],
          extraImg1 = data[1];
      jQuery('#previewImg').val(previewId);
      jQuery('#preExtraImg').val(extraImg1);
      jQuery('#enterText').val(enterText);
      jQuery('#chooseFont1').val(Font1);
      jQuery('#enterEvent').val(enterEvent);
      jQuery('#chooseFont2').val(Font2);
      jQuery('#addInfo').val(additionalInfo);
      //console.log('Server response:', data);
      const fileInputs = document.querySelectorAll('.upload_image input[type="file"]');
      handleUpload(fileInputs,previewId);
    })
    .catch(error => console.error('Error uploading images:', error));
  },100);
});

function loadMark(id,canvas,size){
  wMark = document.getElementById('wm_collage');
  svgMrk = wMark.innerHTML;
  fabric.loadSVGFromString(svgMrk, function(objects,options){
    loadedObject = fabric.util.groupSVGElements(objects, options);
    loadedObject.scaleToWidth(cWidth);
    loadedObject.set({
      left: cWidth / 2,
      top: cHeight / 2,
      originX: 'center',
      originY: 'center',
      objectCaching: false,
      selectable: false
    });
    canvas.add(loadedObject);
    loadedObject.bringToFront();
    loadedObject.setCoords();
    canvas.remove(clockNeedlesImage);
    canvas.renderAll();
  });
  canvasMakeImg(canvas,size);
  window[id+'t'] = canvas.toDataURL('image/png');
  console.log(window[id+'t']);
}

function removeMark(canvas,size){
  canvas.remove(loadedObject).renderAll();
  canvasMakeImg(canvas,size);
}